module.exports = __webpack_public_path__ + "media/icons/key-s-15685871.svg";